<template>
  <div id="c-cmdpanel-c" ref="consoleLogWrapper">
    <div class="console-hd">
      <span>控制台:</span>
      <el-button class="clear-btn" type="text" icon="el-icon-delete" @click="clearHandler">清理控制台</el-button>
    </div>
    <ConsolePanel ref="consolePanel"></ConsolePanel>
    <SocketFunc v-if="isSocket"></SocketFunc>
  </div>
</template>

<script type="text/babel">
  import { mapGetters } from 'vuex';
  import ConsolePanel from '../ide/ConsolePanel'
  import SocketFunc from '../ide/SocketFunc'
  import { emitEvent, onEvent } from '../../utils/eventBus/vueEvent'
  import Events from '../../scripts/events/index'
  import Question from '../../scripts/common/question'
  import consoleStyle from '../ide/consoleStyle'
  import Message from '../../scripts/message'
  import timer from '../../scripts/timer'
  import { getQceitQuery } from '../../store/modules/ide';
  import answerApi from '../../api/answer'
  // import iframe from '../../scripts/iframe/index'
  import aegis from '../../scripts/aegis'
  // const Base64 = require('js-base64').Base64
  import HttpRunner from '../../scripts/http-runner';
  // import HttpTest from '../../scripts/http-test';


  export default {
    name: 'c-cmdpanel-c',
    data() {
      return {
        getTestEndTime: 0,
      }
    },
    computed: {
      ...mapGetters(['getQuestionInfo', 'runToken', 'isRunning', 'isRunLocal', 'language', 'questionInfoReady']),
      isSocket() {
        return this.questionInfoReady && !this.isRunLocal && !HttpRunner.isHttp();
      },
    },
    components: { ConsolePanel, SocketFunc },
    mounted() {
      onEvent(Events.TEST_CODE_RES, this.testResHandler)
      onEvent(Events.TEST_ENDED, this.testEndHandler)

      onEvent(Events.RUN_CODE_RUN_RES, this.runResHandler)
      onEvent(Events.RUN_CODE_INPUT_RES, this.handleInput)
      onEvent(Events.RUN_CODE_STOP_RES, this.stopResHandler)
      onEvent(Events.RUN_CODE_STOPED, this.stopedHandler)

    },
    methods: {
      clearHandler() {
        emitEvent(Events.OUTPUT_CONSOLE, { result: '', clear: true });
      },

      // socket func:
      stopedHandler(data) {
        this.$store.dispatch('setIsRunning', false)
        if (data.error) {
          emitEvent(Events.OUTPUT_CONSOLE, { result: `${consoleStyle.getRun('...运行结束:')} ${consoleStyle.getWarn(data.error)}` })
        } else {
          emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getRun('...运行结束') })
        }
      },
      runResHandler(res) {
        if (res.Code === 0 && res.data && res.data.sessionId) {
          this.$store.dispatch('setRunningData', res.data)
          emitEvent(Events.NEED_INPUT, res.data)
        } else {
          this.$message.error(Message.getShortMsg(res.Msg, 400))
          console.error('runResHandler error:', res)
          this.$store.dispatch('setIsRunning', false)
          emitEvent(Events.OUTPUT_CONSOLE,
            consoleStyle.getErr(`运行失败: ${res.Code} - ${res.Msg} - ${res.data && res.data.sessionId || 0}`) );
          emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getRun('...运行结束') });
          aegis.report(`runResHandler error2: ${res.Code} - ${res.Msg} -- ${JSON.stringify(res)}`);
        }

        if (timer.getTime(timer.timers.run.key)) {
          aegis.reportT({
            name: 'socket-runRes',
            duration: timer.getTime(timer.timers.run.key),
            ext1: this.language.key,
            ext2: String(res.Code),
          })
        }
        timer.clearTimer(timer.timers.run.key);
      },

      stopResHandler(res) {
        if (res.Code !== 0) {
          // this.$message.error(res.Msg)
          console.error('stopResHandler error:', res)
          emitEvent(Events.OUTPUT_CONSOLE, consoleStyle.getWarn(`运行结束: ${res.Code} - ${res.Msg}`))
        } else {
          if (HttpRunner.isHttp()) {
            emitEvent(Events.OUTPUT_CONSOLE, '运行结束')
          }
        }
        this.$store.dispatch('setIsRunning', false)
        timer.clearTimer(timer.timers.stop.key);
      },
      handleInput(res) {
        if (res.Code !== 0) {
          this.$message.error(res.Msg)
          console.error('handleInput error:', res)
          emitEvent(Events.OUTPUT_CONSOLE, consoleStyle.getErr(`输入异常: ${res.Code} - ${res.Msg}`))
        }
      },
      testResHandler(res, type) {
        if (res.Code !== 0) {
          this.$message.error(`${res.Msg}${type}`)
          console.error('testResHandler error:', res, type)
          emitEvent(Events.OUTPUT_CONSOLE, consoleStyle.getErr(`测试失败: ${res.Code} - ${res.Msg} - ${type || ''}`))
          emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getTest('...测试结束') })
          this.$store.dispatch('setIsTesting', false)
        } else if (res.data && res.data.Status) {
          // data == startTestRsp.Test —— 当有完成当test，才会返回，否则重新发起测试；
          this.testEndHandler(res)
        } else if (res.data && res.data.SolutionID) {
          // 提交测试成功
          timer.setTimer(this.checktestEndCb.bind(this), timer.timers.testEnd.time, timer.timers.testEnd.key, res.data);
        } else {
          emitEvent(Events.OUTPUT_CONSOLE, consoleStyle.getErr(`测试服务器返回异常失败: ${JSON.stringify(res.data)}`))
          console.error('testResHandler err:', JSON.stringify(res))
        }
        timer.clearTimer(timer.timers.test.key);
      },

      // 测试返回超时，启动检查逻辑；
      async checktestEndCb(data) {
        console.error('测试返回超时，启动检查逻辑')
        if (!data || !data.SolutionID) {
          return
        }
        const params = getQceitQuery(this.$route.query, {SolutionID: data.SolutionID})
        const res = await answerApi.getTest(params)
        this.testEndHandler(res)
      },

      testEndHandler(res) {
        if (res.Code !== 0) {
          this.$message.error(res.Msg)
          console.error('testEndHandler error:', res)
          emitEvent(Events.OUTPUT_CONSOLE, consoleStyle.getErr(`测试失败: ${res.Code} - ${res.Msg}`))
        } else if (res.data && res.data.Status) {
          console.warn('testEndHandler Status:', res.data.Status)
          if (res.data.Status === Question.testStatus.STATUS_PASSED.key ) {
            emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getSuccess(Question.testStatus.STATUS_PASSED.label) })
          } else if (res.data.Status === Question.testStatus.STATUS_FAILED.key ) {
            emitEvent(Events.OUTPUT_CONSOLE, { result: `${consoleStyle.getWarn(Question.testStatus.STATUS_FAILED.label)} ${res.data.errMsg || ''}` })
          } else {
            console.error('测试运行异常1', JSON.stringify(res.data))
            emitEvent(Events.OUTPUT_CONSOLE, {result: consoleStyle.getErr(`测试运行异常1:${res.data.Status}，请重新测试`) })
              // result: consoleStyle.getErr(Question.testStatus[res.data.Status] && Question.testStatus[res.data.Status].label || '测试异常') })
          }
        } else {
          console.error('测试运行异常2', JSON.stringify(res.data))
          emitEvent(Events.OUTPUT_CONSOLE, {result: consoleStyle.getErr(`测试运行异常2:${JSON.stringify(res.data)}，请重新测试`) })
        }
        emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getTest('...测试结束') })
        this.$store.dispatch('setIsTesting', false)
        this.$store.dispatch('getAnswerList', this.$route.query)

        if (timer.getTime(timer.timers.testEnd.key)) {
          aegis.reportT({
            name: 'socket-testEnd',
            duration: timer.getTime(timer.timers.testEnd.key),
            ext1: String(res.Code),
          })
        }

        if (timer.getTime(timer.timers.testGetEnd.key)) {
          aegis.reportT({
            name: 'socket-testGetEnd',
            duration: timer.getTime(timer.timers.testGetEnd.key),
            ext1: String(res.Code),
          })
        }

        timer.clearTimer(timer.timers.testEnd.key);
        timer.clearTimer(timer.timers.testGetEnd.key);
      },
    },
  }
</script>

<style lang="scss">

  @import "../../assets/scss/base/variables.scss";

  #c-cmdpanel-c {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .el-tabs__item {
      height: 30px;
      line-height: 30px;
    }

    .console-hd {
      display: flex;
      justify-content: space-between;
      height: 26px;
      align-items: center;
      padding: 0px $i-s;
      flex-grow: 0;
      margin-bottom: -3px;
      font-size: 12px;

      .clear-btn {
        padding: 0;
      }

      .console-label {
        display: flex;
        z-index: 2;

        .console-label-item {
          width: 90px;
          border: 1px solid $c-border-e8;
          border-top-left-radius: $r-s;
          border-top-right-radius: $r-s;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: $c-bg-white;
          margin-bottom: -9px;
          cursor: pointer;

          &.console-label-item-selected {
            border-bottom: 0px;
          }
        }
      }
    }
  }
</style>
